import { handleGetCollection } from '@/constants/db-collection.constants';
import { getConfig } from '@/configs/config-accessor';
import ApiService from './ApiService';

// Get the API prefix from the config accessor
const getApiPrefix = () => getConfig().newApiPrefix;

interface ISystemConfig_Response<T> {
  _id: string;
  __v: number;
  slug: string;
  data: T;
}

// NAV CONFIG

export interface INavConfig {
  key: string;
  path: string;
  title: string;
  icon: string;
  summary: string;
  description: string;
  type: 'collapse' | 'item' | 'title';
  authority: string[];
  subMenu: INavConfig[];
}

export type GetNavConfigVersion_Response = IResponse<Omit<ISystemConfig_Response<INavConfig[]>, 'data'>[] | null>;
export const getNavConfigVersion = async () => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetNavConfig_Response, DynamicGet_Body>({
    url: `${newApiPrefix}/dynamicmongodb/get`,
    method: 'post',
    data: { collection: handleGetCollection('system-config'), filter: { slug: 'nav' } }
  });
};

export type GetNavConfig_Response = IResponse<ISystemConfig_Response<INavConfig[]>[] | null>;
export const getNavConfig = async () => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetNavConfig_Response, DynamicGet_Body>({
    url: `${newApiPrefix}/dynamicmongodb/get`,
    method: 'post',
    data: { collection: handleGetCollection('system-config'), filter: { slug: 'nav' } }
  });
};

export type SetNavConfig_Body = INavConfig[];
export type SetNavConfig_Response = IResponse<ISystemConfig_Response<INavConfig[]>[] | null>;
export const setNavConfig = async (body: SetNavConfig_Body) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<SetNavConfig_Response, DynamicUpdate_Body<{ data: SetNavConfig_Body }>>({
    url: `${newApiPrefix}/dynamicmongodb/update`,
    method: 'post',
    data: { collection: handleGetCollection('system-config'), filter: { slug: 'nav' }, data: { data: body } }
  });
};

// LIST BUILDER CONFIG

export interface IListBuilderConfig {
  columnOrder: string[];
  columns: object[];
  reservedViewportWidth: number;
  sortInfo: object[];
}

export type GetListBuilderConfig_Response = IResponse<ISystemConfig_Response<IListBuilderConfig[]>[] | null>;
export const getListBuilderConfig = async () => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<GetListBuilderConfig_Response, DynamicGet_Body>({
    url: `${newApiPrefix}/dynamicmongodb/get`,
    method: 'post',
    data: { collection: handleGetCollection('system-config'), filter: { slug: 'listBuilder' } }
  });
};

export type SetListBuilderConfig_Body = IListBuilderConfig[];
export type SetListBuilderConfig_Response = IResponse<ISystemConfig_Response<IListBuilderConfig[]>[] | null>;
export const setListBuilderConfig = async (body: SetListBuilderConfig_Body) => {
  const newApiPrefix = getApiPrefix();
  return ApiService.fetchData<SetListBuilderConfig_Response, DynamicUpdate_Body<{ data: SetListBuilderConfig_Body }>>({
    url: `${newApiPrefix}/dynamicmongodb/update`,
    method: 'patch',
    data: { collection: handleGetCollection('system-config'), filter: { slug: 'listBuilder' }, data: { data: body } }
  });
};
